// generated from 57 samples

import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const llmStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("LLM"),
  step_data: z.object({
    model: z.string().nullable().optional(),
    prompt: z.string().nullable().optional(),
  }),
});
